import React from 'react'
import { DropdownButtonV2, LabraToolTipV2 } from '@labrav/react-components'
import { useFlag } from '@labrav/flags'
import { useStyles } from '../ProductListingV2.styles'
import {
  ExternalPlatformType,
  type CreateNewListingButtonProps,
} from '../types'

export const CreateNewListingButton: React.FC<CreateNewListingButtonProps> = ({
  isFreeTier,
  enableToCreate,
  selectedCloudTypeProductListing,
  externalBaseURL = false,
  externalPlatformType,
  handleCreateListingSelection,
}) => {
  const { classes } = useStyles({})
  const buttonText = 'Add listing'
  const isHubspot = externalPlatformType === ExternalPlatformType.HUBSPOT

  const { flag: microsoftMigrateProductEnable } = useFlag(
    'microsoftMigrateProduct'
  )
  const tooltipDescription = !(
    (selectedCloudTypeProductListing === 'AWS' ||
      selectedCloudTypeProductListing === 'AZURE') &&
    !externalBaseURL &&
    !isHubspot
  )
    ? 'Coming soon'
    : ''

  return (
    <div className={classes.dropdownButton}>
      <LabraToolTipV2
        tooltipPlacement="bottom-end"
        description={tooltipDescription}
      >
        {isFreeTier && !enableToCreate ? (
          <LabraToolTipV2
            tooltipPlacement="bottom"
            description="You have reached the creation limit in the free tier plan."
          >
            <DropdownButtonV2
              variant="contained"
              styleType="primary"
              buttonText={buttonText}
              data-testid={'create-new-listing'}
              disabled
              options={[
                {
                  label: 'Create new listing',
                  route: '',
                  disable: false,
                  key: 'create-new-listing',
                },
                {
                  label: 'Migrate existing product listing',
                  route: '',
                  key: 'migrate-existing-product',
                  disable: false,
                  disabledTooltip: 'Coming soon',
                },
              ]}
              onOptionClick={handleCreateListingSelection}
            />
          </LabraToolTipV2>
        ) : (
          <DropdownButtonV2
            variant="contained"
            styleType="primary"
            buttonText={buttonText}
            data-testid={'create-new-listing'}
            disabled={
              !(
                (selectedCloudTypeProductListing === 'AWS' ||
                  (microsoftMigrateProductEnable?.value &&
                    selectedCloudTypeProductListing === 'AZURE')) &&
                !externalBaseURL &&
                !isHubspot &&
                enableToCreate
              )
            }
            options={[
              {
                label: 'Create new listing',
                route: '',
                disable: selectedCloudTypeProductListing === 'AZURE',
                key: 'create-new-listing',
                disabledTooltip:
                  selectedCloudTypeProductListing === 'AZURE'
                    ? 'Coming soon'
                    : '',
              },
              {
                label: 'Migrate existing product listing',
                route: '',
                key: 'migrate-existing-product',
                disable: false,
                disabledTooltip: 'Coming soon',
              },
            ]}
            onOptionClick={handleCreateListingSelection}
          />
        )}
      </LabraToolTipV2>
    </div>
  )
}
